import script from "./admin_statisticsPage_new.vue?vue&type=script&setup=true&lang=js"
export * from "./admin_statisticsPage_new.vue?vue&type=script&setup=true&lang=js"

import "./admin_statisticsPage_new.vue?vue&type=style&index=0&id=2eca73a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2eca73a5"]])

export default __exports__